<template>
  <component :is="component" :config="accountConfig()" @close="$emit('close', $event)"></component>
  <div class="app-inner-layout__sidebar card">
    <slot name="client-filter">
      <div class="app-inner-layout__top-pane p-3">
        <div class="pane-left">
          <Select class="select" :allowEmpty="false" track-by="id" label="text" v-model="query.client.tagSelected" :options="dropDownMessenger" @select="dropDownMessengerChange($event, 'selected')"></Select>
        </div>
        <div class="pane-right pt-3">
          <div class="input-group">
            <input placeholder="Search..." type="text" class="form-control" @keyup.enter="filterClientSubmit()" @change="changeSearchClient($event.target.value)" />
          </div>
        </div>
        <div class="pane-right pt-3">
          <button class="btn-transition btn btn-outline-primary w-100" @click="filterClientSubmit()">Filter</button>
        </div>
        <div class="pane-right pt-3">
          <PageNav :store="store" :config="navConfig" @pageChange="pageChange()" />
        </div>
      </div>
    </slot>

    <div class="bg-white">
      <div class="app-inner-layout__sidebar-body" ref="clientSidebar">
        <div v-if="clients.length == 0" class="h5 text-center text-secondary">No customers</div>
        <ul v-else class="nav flex-column">
          <li v-for="_client in clients" :key="_client.id" :class="'item ' + [_client.readed == true ? 'item-readed' : 'item-unread']">
            <button type="button" tabindex="0" :class="'dropdown-item' + [_client.client_id == query.client.selected ? ' active' : '']">
              <div class="widget-content p-0" @click="chooseClient(_client.client_id)">
                <div class="widget-content-wrapper">
                  <div class="widget-content-left mr-3">
                    <img width="42" class="rounded-circle" :src="_client.information.avatar_url" />
                  </div>
                  <div class="widget-content-left">
                    <div class="widget-heading" v-html="_client.information.display_name"></div>
                    <div class="widget-subheading">
                      <p class="client-excerpt mb-0" v-html="_client.excerpt"></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dropdown d-inline-block show">
                <div class="icon-wrapper" data-toggle="dropdown">
                  <i class="fa fa-fw"></i>
                </div>
                <div tabindex="-1" role="menu" class="dropdown-menu" @click="$event.currentTarget.classList.remove('show')">
                  <a class="action make-read" href="#make-read" @click.prevent="conversationAction(_client.client_id, 'readed')">Make Read</a>
                  <a class="action make-unread" href="#make-unread" @click.prevent="conversationAction(_client.client_id, 'unread')">Make UnRead</a>
                </div>
              </div>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div :class="'app-inner-layout__content card' + [!query.accounts.selected || !query.client.selected ? ' has-overlay' : '']">
    <div class="table-responsive" ref="messengerWrapper">
      <div class="app-inner-layout__top-pane">
        <div class="pane-left">
          <div class="mobile-app-menu-btn">
            <button type="button" class="hamburger hamburger--elastic">
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
            </button>
          </div>
          <div class="avatar-icon-wrapper mr-2">
            <div class="avatar-icon avatar-icon-xl rounded">
              <img width="82" :src="conversation.buyer.avatar_url" />
            </div>
          </div>
          <h4 class="mb-0 text-nowrap">
            {{ conversation.buyer.display_name }}
          </h4>
        </div>
        <div class="pane-right float-right attachment">
          <a v-if="conversation.order.url" :href="conversation.order.url" target="_blank" class="badge badge-success ml-0 cursor-pointer">Order</a>
          <a v-if="conversation.product.url" :href="conversation.product.url" target="_blank" class="badge badge-success ml-0 cursor-pointer">Product</a>
        </div>
      </div>
      <div class="chat-wrapper" ref="messegerContent">
        <div class="clearfix">
          <div v-for="messenger in conversation.messengers" :key="messenger.message_id" :class="[messenger.me == true ? 'float-right' : '']">
            <div :class="'chat-box-wrapper flex-wrap' + [messenger.me == true ? ' chat-box-wrapper-right' : '']">
              <div v-if="messenger.images" class="messenger-image-wrapper preview-container">
                <div v-for="image in messenger.images" :key="image.image_id" class="img-preview" @click="previewImage(image.url)">
                  <img :src="image.url" />
                </div>
              </div>
              <div class="avatar-icon-wrapper">
                <div class="avatar-icon-wrapper ml-1">
                  <div class="avatar-icon avatar-icon-lg rounded">
                    <img v-if="messenger.me != true" :src="conversation.buyer.avatar_url" />
                    <img v-else :src="noThumbnail" />
                  </div>
                </div>
              </div>
              <div class="chat-messenger">
                <div class="chat-box" v-html="messenger.message"></div>
                <small class="opacity-6">
                  <i class="fa fa-calendar-alt mr-1"></i>
                  <span v-html="messenger.date_created"></span>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-wrap align-items-center input-messenger">
        <div class="position-relative">
          <span v-if="query.conversation.attachment.name" @click="previewImage(query.conversation.attachment.src)" class="image-messenger">
            <span>{{ query.conversation.attachment.name }}</span>
          </span>
        </div>
        <div class="position-relative">
          <textarea type="text" name="msg" class="form-control" :value="query.conversation.message" placeholder="Send messenger" @change="changeMessenger($event.currentTarget.value)"></textarea>
          <span class="btn-upload add-images">
            <input type="file" id="upload-media" @change="uploadImage($event)" />
            <svg class="a8c37x1j ms05siws hr662l2t b7h9ocf4" height="20px" width="20px" viewBox="0 -1 17 17">
              <g fill="none" fill-rule="evenodd">
                <path d="M2.882 13.13C3.476 4.743 3.773.48 3.773.348L2.195.516c-.7.1-1.478.647-1.478 1.647l1.092 11.419c0 .5.2.9.4 1.3.4.2.7.4.9.4h.4c-.6-.6-.727-.951-.627-2.151z" class="background-svg"></path>
                <circle cx="8.5" cy="4.5" r="1.5" class="svg"></circle>
                <path d="M14 6.2c-.2-.2-.6-.3-.8-.1l-2.8 2.4c-.2.1-.2.4 0 .6l.6.7c.2.2.2.6-.1.8-.1.1-.2.1-.4.1s-.3-.1-.4-.2L8.3 8.3c-.2-.2-.6-.3-.8-.1l-2.6 2-.4 3.1c0 .5.2 1.6.7 1.7l8.8.6c.2 0 .5 0 .7-.2.2-.2.5-.7.6-.9l.6-5.9L14 6.2z" class="background-svg"></path>
                <path d="M13.9 15.5l-8.2-.7c-.7-.1-1.3-.8-1.3-1.6l1-11.4C5.5 1 6.2.5 7 .5l8.2.7c.8.1 1.3.8 1.3 1.6l-1 11.4c-.1.8-.8 1.4-1.6 1.3z" stroke-linecap="round" stroke-linejoin="round" class="border-svg"></path>
              </g>
            </svg>
          </span>
          <svg class="submit" height="20px" width="20px" viewBox="0 0 24 24" @click="sendMessenger()">
            <path d="M16.6915026,12.4744748 L3.50612381,13.2599618 C3.19218622,13.2599618 3.03521743,13.4170592 3.03521743,13.5741566 L1.15159189,20.0151496 C0.8376543,20.8006365 0.99,21.89 1.77946707,22.52 C2.41,22.99 3.50612381,23.1 4.13399899,22.8429026 L21.714504,14.0454487 C22.6563168,13.5741566 23.1272231,12.6315722 22.9702544,11.6889879 C22.8132856,11.0605983 22.3423792,10.4322088 21.714504,10.118014 L4.13399899,1.16346272 C3.34915502,0.9 2.40734225,1.00636533 1.77946707,1.4776575 C0.994623095,2.10604706 0.8376543,3.0486314 1.15159189,3.99121575 L3.03521743,10.4322088 C3.03521743,10.5893061 3.34915502,10.7464035 3.50612381,10.7464035 L16.6915026,11.5318905 C16.6915026,11.5318905 17.1624089,11.5318905 17.1624089,12.0031827 C17.1624089,12.4744748 16.6915026,12.4744748 16.6915026,12.4744748 Z" fill-rule="evenodd" stroke="none"></path>
          </svg>
          <div class="img-preview-wrapper w-100"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageNav from '@/components/PageNav.vue'

export default {
  components: {
    PageNav
    //ImagePreviewModal,
  },
  data() {
    return {
      component: 'Black',
      noThumbnail: '/assets/images/shop-icon.png',
      query: {
        accounts: {
          selected: false,
          page: 1,
          search: '',
          total: false
        },
        client: {
          tagSelected: {
            id: 'inbox',
            text: 'Inbox'
          }
        },
        conversation: {
          message: '',
          attachment: {
            name: false,
            src: false
          }
        }
      },
      accounts: {},
      dropDownMessenger: [
        { id: 'inbox', text: 'Inbox' },
        { id: 'send', text: 'Send' },
        { id: 'all', text: 'All' },
        { id: 'unread', text: 'Unread' },
        { id: 'spam', text: 'Spam' },
        { id: 'trash', text: 'Recycling bin' }
      ]
    }
  },
  computed: {
    storeId() {
      return 'account-message'
    },
    indexUri() {
      return 'account-message'
    },
    /* accounts() {
      let accounts = this.store.getter('accounts');
      return _.isArray(accounts) ? accounts : [];
    }, */
    clients() {
      let clients = this.store.getter('clients')
      return _.isArray(clients) ? clients : []
    },
    conversation() {
      let conversation = Object.assign(
        {},
        {
          buyer: {
            user_id: '',
            avatar_url: this.noThumbnail,
            display_name: 'No Custommer'
          },
          messengers: [],
          attachment: [],
          order: {},
          product: {}
        },
        this.store.getter('conversation')
      )
      //this.$util.sort(conversation.messengers);
      return conversation
    },
    navConfig() {
      return {
        keys: ['clientQuery']
      }
    }
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
    this.$refs.accountSidebar.addEventListener('scroll', () => {
      if (this.query.accounts.total > 0 || this.query.accounts.total === false) {
        let element = this.$refs.accountSidebar
        if (element.scrollHeight - element.scrollTop <= element.clientHeight + 50) {
          this.reloadAccountData()
        }
      }
    })

    this.$refs.messegerContent.addEventListener('scroll', () => {
      if (this.conversation.messengers.length > 0) {
        let element = this.$refs.messegerContent
        if (element.scrollTop <= 50) {
          this.loadMoreMessenger()
        }
      }
    })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    accountConfig() {
      return {
        query: this.query,
        accounts: this.accounts
      }
    },
    reloadAccountData() {
      this.fetchData(
        {
          page: this.query.accounts.page + 1,
          search: this.query.accounts.search
        },
        {
          $el: this.$refs.accountSidebar
        }
      )
    },
    setUpData(rawData, args) {
      if (!_.isArray(rawData.items)) return
      let accounts = Object.values(this.accounts)
      if (parseInt(args.page) < 2) {
        accounts = []
      }

      rawData.items.forEach((items) => {
        items.children.forEach((item) => {
          item.server = items.text
          accounts.push(item)
        })
      })

      this.query.accounts = Object.assign(this.query.accounts, {
        search: args.search,
        total: rawData.total_items,
        page: parseInt(args.page) > 0 ? parseInt(args.page) : 1
      })

      this.accounts = accounts
    },
    onResize() {
      const getOffsetTop = (element) => {
        let offsetTop = 0
        while (element) {
          offsetTop += element.offsetTop
          element = element.offsetParent
        }
        return offsetTop
      }
      // let autoHeight = ['clientSidebar', 'accountSidebar']
      // autoHeight.forEach((elem) => {
      //   this.$refs[elem].style.height = window.innerHeight - getOffsetTop(this.$refs[elem]) + 'px'
      // })
      // this.$refs.messegerContent.style.height = window.innerHeight - getOffsetTop(this.$refs.messegerContent) - 80 + 'px'
    },
    chooseAccount(accoundId) {
      this.query.accounts.selected = accoundId
      this.initClient()
    },
    changeSearchAccount(search) {
      this.query.accounts.search = search
    },
    searchAccount() {
      this.query.accounts.page = 0
      this.reloadAccountData()
    }
    /* dropDownMessengerChange(value) {
      this.query.client.tagSelected = value;
    },
    changeSearchClient(value) {
      this.query.client.search = value;
    },
    filterClientSubmit() {
      this.query.client.page = 1;
      this.initClient();
    },
    pageChange() {
      this.initClient();
    },
    initClient() {
      let data = {
        page: this.query.client.page,
        tag: this.query.client.tagSelected.id,
        search: this.query.client.search,
      };

      if (String(this.query.accounts.selected).length > 0 && data.tag.length > 0) {
        this.$util.post(
          `account-message/get-client/${this.query.accounts.selected}`,
          data,
          this.$refs.clientSidebar,
          {
            done: (response) => {
              if (!_.isArray(response.clients)) return;
              this.query.client = {
                total: response.pagination.total,
                limit: response.pagination.limit,
                page: parseInt(response.pagination.page) > 0 ? parseInt(response.pagination.page) : 1,
              };
              this.store.commit("clients", response.clients);
            }
          },
          {
            method: "get",
          }
        );
      } else {
        this.$util.notify({
          status: "warning",
          text: "Please choose account!",
        });
      }
    },
    chooseClient(clientId) {
      this.query.client.selected = clientId;
      this.initMessenger();
      this.query.conversation.attachment = {
        name: false,
        id: false,
        src: false,
      };
    },
    initMessenger() {
      let data = {
        client_id: this.query.client.selected,
      };

      if (String(data.account_id).length > 0 && String(data.client_id).length > 0) {
        this.$util.post(
          `account-message/get-messenger${this.query.accounts.selected}`,
          data,
          this.$refs.messengerWrapper,
          {
            done: (response) => {
              if (!_.isArray(response.messengers)) return;
              this.store.commit("conversation", {
                messengers: response.messengers,
                buyer: response.buyer,
                order: response.order,
                product: response.product,
              });
              this.store.commit("clients", response.clients);

              let accounts = this.store.getter('accounts');
              accounts.forEach((account, index) => {
                if (account.id == data.account_id) {
                  this.store.commit(
                    `accounts.${index}.notification`,
                    response.notification
                  );
                  return false;
                }
              });

              let clients = this.store.getter('clients');

              if (!_.isArray(clients)) {
                clients = [];
              }

              clients.forEach((client) => {
                if (client.client_id == this.query.client.selected) {
                  client.readed = true;
                  return false;
                }
              });

              this.store.commit("clients", clients);

              if (response.messengers.length > 0) {
                let element = this.$refs.messegerContent;
                let scrollInterval = setInterval(() => {
                  if (element.scrollHeight > 0) {
                    element.scrollTo(0, element.scrollHeight - element.clientHeight);
                    clearInterval(scrollInterval);
                  }
                }, 50);
              }
            }
          },
          {
            method: "get",
          }
        );
      } else {
        this.$util.notify({
          status: "warning",
          text: "Please choose account and customer!",
        });
      }
    },
    loadMoreMessenger() {
      let data = {
        account_id: this.query.accounts.selected,
        client_id: this.query.client.selected,
        buyer_id: this.conversation.buyer.user_id,
        offset: 0,
      };

      if (String(data.account_id).length > 0 && String(data.client_id).length > 0) {
        let messengers = Object.values(this.store.getter('conversation.messengers'));
        data.offset = messengers[0].priority;
        if (data.offset > 1) {
          this.$util.post(
            "account-message/load-more",
            data,
            this.$refs.messengerWrapper,
            {
              done: (response) => {
                if (!_.isArray(response.messengers)) return;
                messengers = messengers.concat(Object.values(response.messengers));
                messengers = this.$util.sort(messengers);
                this.store.commit("conversation.messengers", messengers);
              }
            }
          );
        }
      }
    },
    conversationAction(client_id, action) {
      let data = {
        account_id: this.query.accounts.selected,
        client_id: client_id,
        tag: action,
      };
      this.$util.post("account-message/conversation-action", data, this.$el, {
        done: (response) => {
          if (response.status == "success") {
            let clients = this.store.getter('clients');
            let accounts = this.store.getter('accounts');

            if (!_.isArray(clients)) {
              clients = [];
            }
            if (!_.isArray(accounts)) {
              accounts = [];
            }
            clients.forEach((client) => {
              if (client.client_id == client_id) {
                if (action == "readed") {
                  client.readed = true;
                } else if (action == "unread") {
                  client.readed = false;
                }
                return false;
              }
            });
            this.store.commit("clients", clients);

            accounts.forEach((account, index) => {
              if (account.id == data.account_id) {
                this.store.commit(
                  `accounts.${index}.notification`,
                  response.notification
                );
                return false;
              }
            });
          }
        }
      });
    },
    changeMessenger(value) {
      this.query.conversation.message = value;
    },
    previewImage(url) {
      this.store.commit("modal", {
        _visible: true,
        src: url,
      });
    },
    uploadImage(e) {
      let $this = e.currentTarget;
      let file = $this.files[0];
      this.query.conversation.attachment = {
        name: "Uploading...",
        id: false,
        src: URL.createObjectURL(file),
      };
      this.$util.uploadFile(
        file,
        this.$refs.imageMessage,
        {
          done: (response) => {
            if (response.status == "success" && !_.isUndefined(response.image)) {
              response.image.src = URL.createObjectURL(file);
              response.image.name = file.name;
              this.query.conversation.attachment = response.image;
            } else {
              this.query.conversation.attachment = {
                name: "Upload Fail",
                id: false,
                src: false,
              };
            }
          },
          error: () => {
            this.query.conversation.attachment = {
              name: "Upload Fail",
              id: false,
              src: false,
            };
          },
        },
        {
          account_id: this.query.accounts.selected,
          client_id: this.query.client.selected,
          uploadUrl: this.$util.options.api.upload,
          action: "account-message/upload-attachment",
        }
      );
    },
    sendMessenger() {
      let data = {
        account_id: this.query.accounts.selected,
        client_id: this.query.client.selected,
        message: this.query.conversation.message,
        attachment: this.query.conversation.attachment,
      };
      this.$util.post("account-message/send-messenger", data, this.$el, {
        done: (response) => {
          if (!_.isObjectLike(response.message)) return;
          let messengers = this.store.getter('conversation.messengers');
          if (!_.isArray(messengers)) {
            messengers = [];
          }
          if (!_.isUndefined(response.message.message_id)) {
            messengers.push(response.message);
            this.store.commit("conversation.messengers", messengers);
            this.query.conversation.message = "";
            let element = this.$refs.messegerContent;
            let scrollInterval = setInterval(() => {
              if (element.scrollHeight > 0) {
                element.scrollTo(0, element.scrollHeight - element.clientHeight);
                clearInterval(scrollInterval);
              }
            }, 50);
          }
        }
      });
    }, */
  }
}
</script>
<style lang="scss">
.scroll-to-top {
  display: none;
}
.page-account-message-container {
  margin: -30px;
  border-top: 1px solid #e9ecef;
  .app-inner-layout__top-pane {
    .pane-right.attachment {
      > a {
        color: #fff;
        cursor: pointer;
        user-select: none;
      }
    }
  }
  .app-inner-layout__wrapper {
    min-height: 0;
    .app-inner-layout__sidebar.card {
      width: 300px;
      flex: 0 0 300px;
      border-left: 0;
      .displaying-num {
        display: none;
      }
      .tablenav-pages {
        display: flex;
        justify-content: center;
        float: none;
      }
      .dropdown-item {
        min-height: 80px;
        border-bottom: 1px solid #efefef;
      }
      .client-excerpt {
        max-width: 170px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .message-count {
        position: absolute;
        top: -4px;
        right: -4px;
        width: 22px;
        height: 22px;
        background: #c50000;
        border-radius: 50%;
        border: 1px solid #fff;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
      }
      .app-inner-layout__sidebar-body {
        overflow: auto;
        overflow-x: hidden;
        &::-webkit-scrollbar {
          width: 20px;
        }
        &::-webkit-scrollbar-track {
          background-color: transparent;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #d6dee1;
          border-radius: 20px;
          border: 6px solid transparent;
          background-clip: content-box;
          &:hover {
            background-color: #a8bbbf;
          }
        }
        .dropdown-item {
          position: relative;
          &.active {
            .icon-wrapper {
              i {
                color: #fff !important;
              }
            }
          }
        }
        .item {
          &.item-readed,
          &.item-unread {
            > .dropdown-item {
              padding: 0 !important;
              min-height: 0 !important;
              > .widget-content {
                min-height: 80px;
                padding: 0.4rem 1.5rem !important;
                display: flex;
              }
            }
            .dropdown {
              position: absolute;
              right: 0;
              z-index: 999999999;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
              > div.icon-wrapper {
                width: 28px;
                height: 28px;
                padding: 5px;
              }
              .dropdown-menu {
                left: -15px !important;
              }
              i {
                color: #333;
                font-size: 16px;
              }
              a {
                display: block;
                padding: 10px 20px;
                color: #333;
                &:hover {
                  color: #fff;
                  background-color: #3f6ad8;
                }
              }
            }
          }
        }

        .item.item-readed {
          .widget-content {
            opacity: 0.7;
          }

          /* .fa-fw {
            content: ;
            &:hover {
              content: ;
            }
          } */
        }
        .item.item-unread {
          .dropdown-item {
            background: #c5e3ff;
            border-bottom: 1px solid #2196f3;
          }
          .widget-content {
            opacity: 1;
          }
          .widget-heading {
            opacity: 1;
            font-weight: 500;
          }
          .widget-subheading {
            opacity: 1;
          }
          .dropdown {
            i {
              color: #333;
            }
          }
        }
      }
    }
    .app-inner-layout__content.card {
      &.has-overlay {
        &::before {
          content: '';
          display: block;
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 999;
          background: #fff;
          opacity: 0.5;
        }
      }
      .chat-wrapper {
        overflow: auto;
        &::-webkit-scrollbar {
          width: 20px;
        }
        &::-webkit-scrollbar-track {
          background-color: transparent;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #d6dee1;
          border-radius: 20px;
          border: 6px solid transparent;
          background-clip: content-box;
          &:hover {
            background-color: #a8bbbf;
          }
        }
        > div > div {
          clear: both;
          max-width: 90%;
        }
        .chat-box {
          display: block;
        }
        .chat-messenger {
          flex: 1;
        }
        .messenger-image-wrapper {
          display: flex;
          order: 0;
          width: 100%;
          margin-bottom: 5px;
          .img-preview {
            width: 80px;
            height: 80px;
            margin-left: 5px;
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              border: 1px solid #dfdfdf;
              border-radius: var(--border-radius, 0.25rem);
            }
          }
        }
        .float-right .messenger-image-wrapper {
          justify-content: flex-end;
        }
        .chat-box-wrapper.chat-box-wrapper-right {
          justify-content: flex-end;
          .avatar-icon-wrapper {
            order: 2;
          }
          .chat-messenger {
            order: 1;
          }
        }
      }
      .input-messenger {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        z-index: 10;
        background: #fff;
        margin: 10px 0px;
        > div {
          width: 100%;
          padding: 0 20px;
        }
        textarea {
          padding-right: 80px;
          background: #f5f5f5;
          border: 0;
          border-radius: var(--border-radius, 0.25rem);
          flex: 1;
          font-size: 14px;
          &::-webkit-scrollbar {
            width: 20px;
          }
          &::-webkit-scrollbar-track {
            background-color: transparent;
          }
          &::-webkit-scrollbar-thumb {
            background-color: #d6dee1;
            border-radius: 20px;
            border: 6px solid transparent;
            background-clip: content-box;
            &:hover {
              background-color: #a8bbbf;
            }
          }
        }
        .submit {
          position: absolute;
          cursor: pointer;
          top: calc(50% - 10px);
          right: 35px;
          fill: #ccc;
          z-index: 9;
          top: 0;
          height: 40px;
          &:hover {
            fill: #3f6ad8;
          }
        }
        .image-messenger {
          background: #f5f5f5;
          padding: 5px 15px;
          margin-bottom: 5px;
          display: inline-block;
          border-radius: 100px;
          max-width: 100%;
          cursor: pointer;
          user-select: none;
          span {
            white-space: nowrap;
            overflow: hidden;
            display: block;
          }
        }
        .add-images {
          position: absolute;
          width: 40px;
          height: 36px;
          right: 56px;
          cursor: pointer;
          top: 0;
          margin: 0 0;
          display: flex;
          align-items: center;
          justify-content: center;
          .background-svg {
            fill: #ccc;
          }
          .border-svg {
            stroke: #ccc;
          }
          &:hover {
            .background-svg {
              fill: #3f6ad8;
            }
            .border-svg {
              stroke: #3f6ad8;
            }
          }
        }
      }
    }
  }
}
</style>
